import { carePlanRequestsTyped } from "@/api/(requests)/carePlanTyped";
import type { PatientArticulatedGoalsResponse } from "@/core/types";

export async function getArticulatedGoals(
  patientId: string,
): Promise<PatientArticulatedGoalsResponse> {
  return carePlanRequestsTyped.get_patient_articulated_goals({
    context: { showLoader: false },
    patientId,
  });
}
